import {createContext} from 'react'

export const ThemeModeContext = createContext({
  themeMode: 'dark',
  toggleTheme: () => {},
  setThemeMode: () => {},
})
